import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const AGENT_SCENARIOS_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('AGENT_SCENARIOS');
export const AGENT_SCENARIOS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	AGENT_SCENARIOS_CRUD_ACTION_CONSTANTS
);
